import { Select2AjaxGetClients } from "./select2AjaxGetClients";
import { TomSelectDefault } from "./tom-select-default";

export function initSelect2Components() {
  try {
    new Select2AjaxGetClients().start();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to start Select2AjaxGetClients:", e);
  }

  try {
    new TomSelectDefault().start();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to start TomSelectDefault:", e);
  }
}

// Auto-initialize for backwards compatibility
initSelect2Components();
